export default __webpack_public_path__ + "static/media/permissions.6219f18a.svg";